import { MayBeNull } from '@wpp-open/core'
import { useMemo } from 'react'

import { TenantGroup } from 'types/groups/groups'
import { Role, RoleGroup } from 'types/roles/roles'

type GroupsAccountsmap = Record<string, { id: string; name: string }[]>

const getGroupedAccounts = (
  { accountId, accountName }: { accountId: string; accountName: string },
  groupId: string,
  acc: GroupsAccountsmap,
) => {
  const newAccount = { id: accountId, name: accountName }
  if (groupId in acc) {
    const groupAccounts = acc[groupId]

    return { ...acc, [groupId]: [...groupAccounts, newAccount] }
  }
  return { ...acc, [groupId]: [newAccount] }
}

export const useGroupsAccountsMap = (
  role?: Role,
  tenantGroups?: MayBeNull<TenantGroup[]>,
  groupId?: string,
): GroupsAccountsmap =>
  useMemo(() => {
    const groups_roles_accounts = role ? role.groups_roles_accounts : []

    if (groupId) {
      return (groups_roles_accounts as RoleGroup[]).reduce<GroupsAccountsmap>((acc, groups_roles_account) => {
        const { account_id: accountId, account_name: accountName } = groups_roles_account

        if (groups_roles_account.group_id !== groupId) {
          return { ...acc }
        }

        return getGroupedAccounts({ accountId, accountName }, groupId, acc)
      }, {})
    }

    return tenantGroups!.reduce<GroupsAccountsmap>((acc, tenantGroup) => {
      const filteredGroupRolesAccounts = groups_roles_accounts.filter(({ group_id }) => group_id === tenantGroup.id)!

      return {
        ...acc,
        ...filteredGroupRolesAccounts.reduce<GroupsAccountsmap>((groupAccountsAcc, roleGroup) => {
          const { group_id: groupId, account_id: accountId, account_name: accountName } = roleGroup

          return getGroupedAccounts({ accountId, accountName }, groupId, groupAccountsAcc)
        }, {}),
      }
    }, {})
  }, [tenantGroups, role, groupId])
